(function () {
  'use strict';

  // QN Huevos - ticket dentro del carrito.
  // El maple es un gancho: el ticket aparece solo cuando NO hay ningun maple en
  // el carrito, y agrega UNO a su precio de lista. No hay precio promocional por
  // codigo; la condicion de compra es el minimo de $500 del pedido.
  // 07/09/2026 - se saco la propiedad decorativa `_qn_huevos_promo` (se sigue
  // reconociendo en carritos viejos) y las constantes de variante sin uso.

  const QNHuevosUpsell = {
    CONFIG: {
      LANDING_PROMO_PRODUCT_ID: '10154045407508',
      CART_PROP_PROMO: '_qn_huevos_promo',
      DRAWER_SELECTOR: '[data-cart-drawer]',
      UPSELL_SELECTOR: '#qnHuevosUpsell',
      ADD_BTN_SELECTOR: '.qn-huevos-variant-btn'
    },

    state: {
      isCheckingCart: false,
      isAdding: false,
      drawerObserver: null,
      bodyObserver: null,
      eventsBound: false
    },

    init() {
      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', () => this.start());
      } else {
        this.start();
      }
    },

    start() {
      this.bindGlobalEvents();
      this.observeBody();
      this.refreshRefs();
      this.observeDrawer();
      this.checkAndUpdate();
    },

    refreshRefs() {
      this.drawer = document.querySelector(this.CONFIG.DRAWER_SELECTOR);
      this.upsellContainer = document.querySelector(this.CONFIG.UPSELL_SELECTOR);
    },

    getConfig() {
      this.refreshRefs();
      const dataset = this.upsellContainer ? this.upsellContainer.dataset : {};

      return {
        promoProductId: String(dataset.productPromo || this.CONFIG.LANDING_PROMO_PRODUCT_ID),
        alsoProductIds: String(dataset.productAlso || '').split(',').map(function (s) { return s.trim(); }).filter(Boolean),
        promoProp: dataset.promoProp || this.CONFIG.CART_PROP_PROMO,
        promoValue: dataset.promoValue || '200',
        maxMaples: parseInt(dataset.maxMaples, 10) || 2
      };
    },

    bindGlobalEvents() {
      if (this.state.eventsBound) return;
      this.state.eventsBound = true;

      document.addEventListener('click', (event) => {
        const btn = event.target.closest(this.CONFIG.ADD_BTN_SELECTOR);
        if (btn) this.agregarMaple(event);
      });

      document.addEventListener('qn:cart:open', () => {
        this.refreshRefs();
        this.observeDrawer();
        this.checkAndUpdate();
      });

      document.addEventListener('qn:cart:updated', () => {
        this.refreshRefs();
        this.observeDrawer();
        this.checkAndUpdate();
      });
    },

    observeBody() {
      if (this.state.bodyObserver) return;

      this.state.bodyObserver = new MutationObserver(() => {
        const prevDrawer = this.drawer;
        this.refreshRefs();

        if (this.drawer && this.drawer !== prevDrawer) {
          this.disconnectDrawerObserver();
          this.observeDrawer();
        }

        if (this.upsellContainer && this.isDrawerOpen()) {
          this.checkAndUpdate();
        }
      });

      this.state.bodyObserver.observe(document.body, {
        childList: true,
        subtree: true
      });
    },

    disconnectDrawerObserver() {
      if (this.state.drawerObserver) {
        this.state.drawerObserver.disconnect();
        this.state.drawerObserver = null;
      }
    },

    observeDrawer() {
      this.refreshRefs();
      if (!this.drawer || this.state.drawerObserver) return;

      this.state.drawerObserver = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
          if (mutation.type === 'attributes' && mutation.attributeName === 'aria-hidden') {
            this.refreshRefs();
            this.checkAndUpdate();
          }
        });
      });

      this.state.drawerObserver.observe(this.drawer, {
        attributes: true,
        attributeFilter: ['aria-hidden']
      });
    },

    isDrawerOpen() {
      this.refreshRefs();
      return !!(this.drawer && this.drawer.getAttribute('aria-hidden') === 'false');
    },

    async getCart() {
      const response = await fetch('/cart.js', {
        method: 'GET',
        headers: { Accept: 'application/json' },
        cache: 'no-store'
      });
      if (!response.ok) throw new Error('No se pudo obtener el carrito');
      return response.json();
    },

    // Un item es "maple" si pertenece al producto promo (cualquiera de sus 4 tamaños)
    // o trae la propiedad de promo. Ya no hay variantes "regular" aparte.
    isPromoItem(item) {
      const config = this.getConfig();
      const productId = item && item.product_id != null ? String(item.product_id) : '';
      const hasPromoProperty = !!(
        item &&
        item.properties &&
        item.properties[config.promoProp] === config.promoValue
      );
      return (
        productId === config.promoProductId ||
        config.alsoProductIds.indexOf(productId) !== -1 ||
        hasPromoProperty
      );
    },

    // Cantidad total de maples en el carrito (sumando todos los tamaños).
    getMapleTotalQty(cart) {
      if (!cart || !cart.items) return 0;
      return cart.items.reduce((acc, item) => {
        return this.isPromoItem(item) ? acc + item.quantity : acc;
      }, 0);
    },

    show() {
      this.refreshRefs();
      if (this.upsellContainer) this.upsellContainer.style.display = 'block';
    },

    hide() {
      this.refreshRefs();
      if (this.upsellContainer) this.upsellContainer.style.display = 'none';
    },

    async checkAndUpdate() {
      this.refreshRefs();
      if (!this.upsellContainer || !this.isDrawerOpen() || this.state.isCheckingCart) return;

      this.state.isCheckingCart = true;

      try {
        const cart = await this.getCart();
        // El ticket del upsell solo aparece si todavía NO hay ningún maple en el carrito.
        // Si ya agregaste uno (en la landing o donde sea), no se muestra.
        if (this.getMapleTotalQty(cart) === 0) {
          this.show();
        } else {
          this.hide();
        }
      } catch (error) {
        console.error('QN-Huevos: error al revisar carrito', error);
      } finally {
        this.state.isCheckingCart = false;
      }
    },

    setButtonLoading(isLoading, targetBtn) {
      const btns = targetBtn
        ? [targetBtn]
        : Array.from(document.querySelectorAll(this.CONFIG.ADD_BTN_SELECTOR));

      btns.forEach((btn) => {
        if (!btn) return;
        const textEl = btn.querySelector('.qn-huevos-btn-text');
        if (!textEl) return;

        if (isLoading) {
          btn.disabled = true;
          textEl.textContent = 'Agregando...';
        } else {
          btn.disabled = false;
          const label = textEl.getAttribute('data-default-label');
          if (label) textEl.textContent = label;
        }
      });
    },

    async agregarMaple(e) {
      if (e) {
        e.preventDefault();
        e.stopPropagation();
      }

      if (this.state.isAdding) return;

      const clickedBtn = e && e.target ? e.target.closest(this.CONFIG.ADD_BTN_SELECTOR) : null;
      if (!clickedBtn) return;
      const variantId = clickedBtn.getAttribute('data-variant-id');
      if (!variantId) return;

      const config = this.getConfig();

      this.state.isAdding = true;
      this.setButtonLoading(true, clickedBtn);

      try {
        const cart = await this.getCart();

        // Tope: máximo 2 maples en total (sumando todos los tamaños).
        if (this.getMapleTotalQty(cart) >= config.maxMaples) {
          this.toast('Ya tenés el máximo de ' + config.maxMaples + ' maples por compra.');
          return;
        }

        // El maple se agrega a su precio de lista. Antes se le pegaba una
        // propiedad `_qn_huevos_promo` que NO cambiaba el precio: era decorativa
        // y hacia creer que habia una promo aplicada. La condicion real de compra
        // es el minimo de $500 del pedido.
        const payload = {
          id: variantId,
          quantity: 1
        };

        const response = await fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json'
          },
          body: JSON.stringify(payload)
        });

        if (!response.ok) {
          const errorData = await response.json().catch(() => ({}));
          throw new Error(errorData.description || 'No se pudo agregar el maple');
        }

        await response.json();
        await this.refrescarDrawer();
        this.toast('¡Maple agregado!');
      } catch (error) {
        console.error('QN-Huevos: error al agregar maple', error);
        alert('Error al agregar. Intentá de nuevo.');
      } finally {
        this.state.isAdding = false;
        this.setButtonLoading(false);
      }
    },

    async refrescarDrawer() {
      const cart = await this.getCart();

      if (window.QNCartDrawer && typeof window.QNCartDrawer.refreshCart === 'function') {
        await window.QNCartDrawer.refreshCart(cart);
      } else if (window.QNCartDrawer && typeof window.QNCartDrawer.renderCart === 'function') {
        await window.QNCartDrawer.renderCart(cart);
      } else if (window.QNCartDrawer && typeof window.QNCartDrawer.fetchCart === 'function') {
        await window.QNCartDrawer.fetchCart(true);
      } else {
        document.dispatchEvent(new CustomEvent('qn:cart:updated', { detail: cart }));
      }

      document.dispatchEvent(new CustomEvent('qn:cart:updated', { detail: cart }));

      setTimeout(() => {
        this.refreshRefs();
        this.checkAndUpdate();
      }, 150);
    },

    toast(message) {
      const existing = document.getElementById('qnHuevosToast');
      if (existing) existing.remove();

      const toast = document.createElement('div');
      toast.id = 'qnHuevosToast';
      toast.textContent = message;
      toast.style.cssText = [
        'position:fixed',
        'left:50%',
        'bottom:20px',
        'transform:translateX(-50%)',
        'background:#27ae60',
        'color:#fff',
        'padding:12px 20px',
        'border-radius:8px',
        'font-size:14px',
        'line-height:1.2',
        'z-index:999999',
        'box-shadow:0 10px 30px rgba(0,0,0,0.15)'
      ].join(';');

      document.body.appendChild(toast);
      setTimeout(() => toast.remove(), 2500);
    }
  };

  window.QNHuevosUpsell = QNHuevosUpsell;
  QNHuevosUpsell.init();
})();
